// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  background-color: #232323;
  height: 100%;
  width: 100%;
}

.home-top-content {
  text-align: center;
  height: 50%;
}

.home-feardragon-logo-container {
  display: inline-block;
  vertical-align: middle;
  width: 40%;
}

.home-feardragon-logo {
  display: inline-block;
  width: 100%;
}

.home-feardragon-text {
  font-size: 10px;
  color: #EDF5E1;
  margin-top: -20px;
}

.home-description {
  color: #8DC049;
  margin-left: 10px;
  display: inline-block;
  vertical-align: middle;
  width: 30%;
  text-align: left;
  font-size: 14px;
}

.home-highlight-reel {
  margin-top: 0px;
  padding-bottom: 50px;
  text-align: center;
  height: 500px;
}

.home-social-media-bar {
  margin-top: 30px;
  text-align: center;
}

.home-social-media-icon {
  width: 100px;
  height: 100px;
  margin: 0px 30px 30px 30px;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B","sourcesContent":[".App {\n  background-color: #232323;\n  height: 100%;\n  width: 100%;\n}\n\n.home-top-content {\n  text-align: center;\n  height: 50%;\n}\n\n.home-feardragon-logo-container {\n  display: inline-block;\n  vertical-align: middle;\n  width: 40%;\n}\n\n.home-feardragon-logo {\n  display: inline-block;\n  width: 100%;\n}\n\n.home-feardragon-text {\n  font-size: 10px;\n  color: #EDF5E1;\n  margin-top: -20px;\n}\n\n.home-description {\n  color: #8DC049;\n  margin-left: 10px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 30%;\n  text-align: left;\n  font-size: 14px;\n}\n\n.home-highlight-reel {\n  margin-top: 0px;\n  padding-bottom: 50px;\n  text-align: center;\n  height: 500px;\n}\n\n.home-social-media-bar {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.home-social-media-icon {\n  width: 100px;\n  height: 100px;\n  margin: 0px 30px 30px 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
